__turbopack_context__.v({
  "showShadow": "MobileFiltersAndActions-module-scss-module__lbAFNW__showShadow",
  "stickyNav": "MobileFiltersAndActions-module-scss-module__lbAFNW__stickyNav",
});
